import React from "react";
import { isFeatureAllowed, STOCKMGMT } from "../../constants/constant";
import { getRestoConversion, getRestoUnitDetails, getRestoUnitOptions } from "./restoBillingConversion";

const RestoUnitSelector = ({ item, disabled = false, onChange }) => {
  if (!isFeatureAllowed(STOCKMGMT)) return null;
  const conversion = getRestoConversion(item);
  if (!conversion) return item.liveStockCount ? <small>Stock: {item.liveStockCount}</small> : null;
  const options = getRestoUnitOptions(item);
  const selectedUnit = options.includes(item.selectedUnit) ? item.selectedUnit : options[0];
  const unitDetails = getRestoUnitDetails(item);
  return (
    <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap", marginTop: 3 }}>
      {options.length > 1 ? (
        <select
          aria-label="Billing unit"
          value={selectedUnit}
          disabled={disabled}
          onChange={(event) => onChange?.(item, event.target.value)}
          style={{ minHeight: 32, maxWidth: 140 }}
        >
          {options.map((unit) => <option key={unit} value={unit}>{unit}</option>)}
        </select>
      ) : <small>Unit: {unitDetails || selectedUnit}</small>}
      {item.liveStockCount && <small>Stock: {item.liveStockCount}</small>}
    </div>
  );
};

export default RestoUnitSelector;
